const wm = {
  // ==================== WAREHOUSE MANAGEMENT ====================
  'lager.title': 'Warehouse Management',
  'lager.subtitle': 'View stock levels and movements',
  'lager.tabStockOverview': 'Stock Overview',
  'lager.tabGoodsReceipt': 'Post Goods Receipt',
  'lager.tabMovements': 'Movements',
  'lager.searchPlaceholder': 'Search material, material number or storage location...',
  'lager.colMaterial': 'Material',
  'lager.colMatnr': 'Material Number',
  'lager.colPlant': 'Plant',
  'lager.colStorageLocation': 'Storage Location',
  'lager.colQuantity': 'Quantity',
  'lager.colUnit': 'Unit',
  'lager.colStatus': 'Status',
  'lager.statusGreen': 'Sufficient',
  'lager.statusYellow': 'Reorder',
  'lager.statusRed': 'Critical',
  'lager.emptyStock': 'No stock entries found',
  'lager.loadingStock': 'Loading stock levels...',
  'lager.errorStock': 'Error loading stock levels',
  'lager.demoBadge': 'Demo',
  'lager.badgeExternal': 'External',
  'lager.grTitle': 'Post Goods Receipt',
  'lager.grMaterialMode': 'Material Selection',
  'lager.grInternalArticle': 'Internal Article',
  'lager.grFreeMatnr': 'Free Material Number',
  'lager.grMaterial': 'Article',
  'lager.grMatnr': 'Material Number',
  'lager.grMaterialName': 'Material Description',
  'lager.grPlant': 'Plant *',
  'lager.grStorageLocation': 'Storage Location *',
  'lager.grQuantity': 'Quantity *',
  'lager.grUnit': 'Unit',
  'lager.grReference': 'Reference / Delivery Note',
  'lager.grSelectPlaceholder': '— Select —',
  'lager.grProductIdPlaceholder': 'Article ID',
  'lager.grMatnrPlaceholder': 'e.g. 100023145',
  'lager.grMaterialNamePlaceholder': 'Optional description',
  'lager.grReferencePlaceholder': 'e.g. delivery note no.',
  'lager.grSubmit': 'Post Goods Receipt',
  'lager.grSubmitting': 'Posting...',
  'lager.grSuccess': 'Goods receipt posted successfully!',
  'lager.grErrorQtyInvalid': 'Quantity must be greater than 0.',
  'lager.grErrorRequired': 'Plant, storage location and quantity are required.',
  'lager.movementsTitle': 'Stock Movements',
  'lager.emptyMovements': 'No movements found',
  'lager.movementGoodsReceipt': 'Goods Receipt',
  'lager.movementTransfer': 'Transfer',
  'lager.movementInventoryDiff': 'Inventory Difference',
  'lager.movementGoodsIssue': 'Goods Issue',
  'lager.colDate': 'Date',
  'lager.colUser': 'User',
  'lager.colReference': 'Reference',
  'lager.noPermission': 'You do not have permission to access warehouse management.',
  'lager.detailTitle': 'Stock Detail',
  'lager.detailMovements': 'Movement History',
  'lager.close': 'Close',
  'lager.minStock': 'Minimum Stock',
  'lager.reorderPoint': 'Reorder Point',
  'lager.filterReset': 'Reset filter',
  'lager.filterMatnr': 'Material Number (exact)',
  'lager.filterMatnrPlaceholder': 'e.g. 100023145',
  'lager.emptyMovementsFiltered': 'No movements found for the selected filters',
  'lager.loadingDetail': 'Loading detail...',
  'lager.errorDetail': 'Error loading stock detail',

  // ==================== LAGER-MODUL Phase 1 (lm.) ====================
  'lm.title': 'Warehouse',
  'lm.subtitle': 'Search stock materials, view inventory and create purchase requisitions',
  'lm.werkLabel': 'Plant',
  'lm.noWerk': 'No plant',
  'lm.searchPlaceholder': 'Search material... (no., name, characteristic)',
  'lm.filterWarengruppe': 'Material Group',
  'lm.filterMaterialart': 'Material Type',
  'lm.filterBestand': 'Stock Status',
  'lm.bestandMit': 'In Stock',
  'lm.bestandOhne': 'Out of Stock',
  'lm.bestandAlle': 'All',
  'lm.resultsCount': '{count} results',
  'lm.stockAsOf': 'stock as of {time} (snapshot; detail reads live)',
  'lm.stockNeverSynced': 'stock never synced from SAP',
  'lm.colMatnr': 'Material No.',
  'lm.colMaktx': 'Description',
  'lm.colWarengruppe': 'Material Group',
  'lm.colMaterialart': 'Material Type',
  'lm.colMe': 'UoM',
  'lm.colBestand': 'Free Available Stock',
  'lm.colMeldebestand': 'Reorder Point',
  'lm.colPreis': 'Last Price',
  'lm.colLieferant': 'Last Vendor',
  'lm.colStatus': 'Status',
  'lm.iconOpenBanf': 'Open purchase requisition exists',
  'lm.iconOpenOrder': 'Open purchase order exists',
  'lm.iconDispo': 'Automatic MRP active',
  'lm.empty': 'No materials found. Please adjust your filter criteria.',
  'lm.loading': 'Loading materials...',
  'lm.error': 'Error loading materials',
  'lm.perPage': 'Rows per page',
  'lm.page': 'Page',
  'lm.filterReset': 'Reset filters',

  // Phase 2 — Inline detail + Quick PR
  'lm.close': 'Close',
  'lm.loadingDetail': 'Loading material details...',
  'lm.errorDetail': 'Error loading material details',
  'lm.detailStammdaten': 'Master Data',
  'lm.detailMaterialart': 'Material Type',
  'lm.detailWarengruppe': 'Material Group',
  'lm.detailMeins': 'Base Unit of Measure',
  'lm.detailBismt': 'Old Material Number',
  'lm.detailBeskz': 'Procurement Type',
  'lm.detailDispo': 'MRP Type',
  'lm.dispoActive': 'Automatic MRP active',
  'lm.detailBestand': 'Stock Overview',
  'lm.detailColLgort': 'Stor. Loc.',
  'lm.detailColLgortName': 'Name',
  'lm.detailColFrei': 'Free Available',
  'lm.detailColQp': 'Quality Insp.',
  'lm.detailColGesperrt': 'Blocked',
  'lm.detailGesamt': 'TOTAL',
  'lm.detailStockOwn': 'Own Stock',
  'lm.detailStockVendorConsignment': 'Vendor Consignment',
  'lm.detailStockAtVendor': 'Stock at Vendor',
  'lm.detailColLieferant': 'Vendor',
  'lm.detailVerfuegbarGesamt': 'Available total (Own + Consignment)',
  'lm.colDavonKonsi': 'incl. consign.',
  'lm.colBeimLieferant': 'at vendor',
  'lm.filterBestandsqualitaet': 'Stock quality',
  'lm.filterKonsignation': 'Consignment only',
  'lm.filterSonderbestand': 'Special stock type',
  'lm.stockTypeOwn': 'Own stock',
  'lm.stockTypeKonsi': 'Consignment',
  'lm.stockTypeAtVendor': 'At vendor',
  'lm.filterLieferant': 'Vendor',
  'lm.filterEinkaeufergruppe': 'Purchasing group',
  'lm.filterSperrbestand': 'Blocked stock',
  'lm.filterQmbestand': 'QI stock',
  'lm.detailMeldebestand': 'Reorder Point',
  'lm.detailSicherheitsbestand': 'Safety Stock',
  'lm.schnellBanf': 'Quick Purchase Requisition',
  'lm.banfMenge': 'Quantity',
  'lm.banfLieferdatum': 'Requested Delivery Date',
  'lm.banfLieferant': 'Preferred Vendor',
  'lm.banfOhneLieferant': 'No vendor (purchasing decides)',
  'lm.banfGeschaetzterPreis': 'Estimated Price',
  'lm.banfInBanf': 'Add to Cart',
  'lm.banfZurDetailBanf': 'Open Detail BANF',
  'lm.banfAuftragErstellen': 'Create order',
  'lm.auftragComingSoon': 'Order creation coming soon (Plant Maintenance).',
  'lm.banfAdded': 'Item added to cart',
  'lm.banfMengeRequired': 'Please enter a quantity > 0',
  'lm.banfLieferdatumRequired': 'Please select a delivery date',
  'lm.detailLetzterPreis': 'Last Price',
  'lm.detailLetzterLieferant': 'Last Vendor',

  // Phase 3a — Suppliers block
  'lm.suppliersTitle': 'Suppliers & Conditions',
  'lm.suppliersLoading': 'Loading suppliers...',
  'lm.suppliersEmpty': 'No supplier info records available.',
  'lm.suppliersError': 'Error loading suppliers',
  'lm.suppliersColSupplier': 'Supplier',
  'lm.suppliersColNetpr': 'Net Price',
  'lm.suppliersColPeinh': 'PU',
  'lm.suppliersColCurrency': 'Currency',
  'lm.suppliersColDelivery': 'Lead Time',
  'lm.suppliersColContract': 'Contract',
  'lm.suppliersColValidTo': 'Valid To',
  'lm.suppliersCheapest': 'Cheapest supplier',
  'lm.suppliersPerUnit': 'per unit',
  'lm.suppliersDeliveryDays': '{days} days',
  'lm.suppliersNoContract': '—',

  // Phase 3a — Purchase history block
  'lm.purchaseHistoryTitle': 'Last Orders',
  'lm.purchaseHistoryLoading': 'Loading purchase history...',
  'lm.purchaseHistoryEmpty': 'No purchase history available.',
  'lm.purchaseHistoryError': 'Error loading purchase history',
  'lm.purchaseHistoryColEbeln': 'Order No.',
  'lm.purchaseHistoryColSupplier': 'Supplier',
  'lm.purchaseHistoryColMenge': 'Quantity',
  'lm.purchaseHistoryColNetpr': 'Net Price',
  'lm.purchaseHistoryColDate': 'Order Date',

  // Phase 3a — Classification block
  'lm.classificationTitle': 'Classification Characteristics',
  'lm.classificationLoading': 'Loading characteristics...',
  'lm.classificationEmpty': 'No classification characteristics available.',
  'lm.classificationError': 'Error loading characteristics',

  // Phase 3a — Quick PR supplier selection
  'lm.banfSupplierSelect': 'Preferred vendor from info record',
  'lm.banfSupplierDelivery': 'Lead time {days} days',

  // Phase 3b — Advanced Filters
  'lm.moreFilters': 'More Filters',
  'lm.lessFilters': 'Less Filters',
  'lm.advancedFiltersTitle': 'Advanced Filters',
  'lm.filterLagerort': 'Storage Location',
  'lm.filterBeschaffungsart': 'Procurement Type',
  'lm.filterDispomerkmal': 'MRP Type',
  'lm.filterBestandVon': 'Stock from',
  'lm.filterBestandBis': 'Stock to',
  'lm.filterOffeneBanf': 'Open Purchase Req.',
  'lm.filterOffeneBestellung': 'Open Purchase Order',
  'lm.filterMit': 'With',
  'lm.filterOhne': 'Without',
  'lm.filterAlle': 'All',
  'lm.beschaffungsartF': 'External Procurement',
  'lm.beschaffungsartE': 'In-house Production',
  'lm.beschaffungsartX': 'Both',
  'lm.handlungsbedarf': 'Action Required',
  'lm.handlungsbedarfHint': 'Stock below reorder point, no open PR/PO — informational only',
  'lm.advancedFilterReset': 'Reset all filters',

  // Phase 3b — Saved Filters
  'lm.savedFiltersTitle': 'Saved Filters',
  'lm.saveCurrent': 'Save current filters',
  'lm.saveModalTitle': 'Save Filter',
  'lm.saveModalName': 'Filter name',
  'lm.saveModalNamePlaceholder': 'e.g. My Main Warehouse Filter',
  'lm.save': 'Save',
  'lm.cancel': 'Cancel',
  'lm.deleteConfirm': 'Really delete this filter?',
  'lm.emptySaved': 'No saved filters available.',
  'lm.savedFilterApplied': 'Filter applied',
  'lm.savedFilterSaved': 'Filter saved',
  'lm.savedFilterDeleted': 'Filter deleted',
  'lm.savedFilterSaveError': 'Could not save filter',
  'lm.savedFilterDeleteError': 'Could not delete filter',
  'lm.savedFilterNameRequired': 'Please enter a name',

  // Phase 3c — Classification characteristic filters
  'lm.merkmaleTitle': 'Classification Characteristics',
  'lm.merkmaleSelectWg': 'Please select a material group to filter by characteristics',
  'lm.merkmaleLoading': 'Loading characteristics...',
  'lm.merkmaleError': 'Error loading characteristics',
  'lm.merkmaleEmpty': 'No classification characteristics available for the selected material groups.',
  'lm.merkmaleVon': 'from',
  'lm.merkmaleBis': 'to',
  'lm.merkmaleLoadError': 'Error loading classification options',

  // Phase 4 — Dashboard
  'lm.dashTitle': 'Warehouse Dashboard',
  'lm.dashMonitoring': 'Monitoring',
  'lm.dashBack': 'Back to Overview',
  'lm.dashLoading': 'Loading dashboard...',
  'lm.dashError': 'Error loading dashboard',
  'lm.dashEmpty': 'No dashboard data available',
  'lm.dashMock': 'Demo',
  'lm.dashBestandswert': 'Total Inventory Value',
  'lm.dashKritisch': 'Critical Stock',
  'lm.dashOffeneBanf': 'Open PRs',
  'lm.dashUmschlag': 'Inventory Turnover',
  'lm.dashUmschlagUnit': 'x / year',
  'lm.dashVerlauf': 'Inventory Trend (12 months)',
  'lm.mockBadge': 'Mock data',
  'lm.stockSourceSap': 'Live from SAP {system} · as of {time} (system time)',
  'lm.stockSourceSnapshot': 'Snapshot from gineex (no live call)',
  'lm.stockSourceLiveError': 'Live call to SAP failed ({error}) – showing snapshot',
  'lm.mvTitle': 'Post goods movement (SAP)',
  'lm.mvHint': 'Preview first (test run in SAP, nothing posted), then confirm and post. Every posting can be reversed.',
  'lm.mvOpTransfer': 'Transfer (311)',
  'lm.mvOpIssueCostCenter': 'Issue to cost center (201)',
  'lm.mvOpScrap': 'Scrapping (551)',
  'lm.mvGrund': 'Movement reason',
  'lm.mvGrundChoose': 'Please choose',
  'lm.mvGrundNone': '(no reason)',
  'lm.mvGrundFree': 'Code (4 digits), optional',
  'lm.mvFrom': 'From storage location',
  'lm.mvTo': 'To storage location',
  'lm.mvKostl': 'Cost center',
  'lm.mvMenge': 'Quantity',
  'lm.mvBudat': 'Posting date (empty = today)',
  'lm.mvText': 'Item text',
  'lm.mvPreview': 'Preview (SAP test run)',
  'lm.mvPreviewOk': 'SAP accepts the posting (movement type {bwart}) – nothing posted yet',
  'lm.mvPreviewFailed': 'SAP rejects the posting',
  'lm.mvConfirmLabel': 'I confirm the posting in SAP',
  'lm.mvPost': 'Post',
  'lm.mvPosted': 'Posted: material document {doc}/{year}',
  'lm.mvPostError': 'Posting failed',
  'lm.mvCancel': 'Reverse',
  'lm.mvCancelled': 'Reversed: {doc} → reversal document {rev}',
  'lm.mvCancelError': 'Reversal failed',
  'lm.mvRecent': 'Postings from gineex (this material)',
  'lm.mvCancelConfirm': 'Post reversal now',
  'lm.mvWmSuffix': '(WM/EWM – not postable)',
  'lm.mvWmHint': 'Warehouse-managed storage locations (WM/EWM) cannot be posted here: {list}.',
  'lm.mvCancelAbort': 'abort',
  'lm.mvUnknown': 'SAP response lost – check the material document in SAP, do not retry',
  'lm.dashDurchlaufzeiten': 'Lead Times by Material Group',
  'lm.dashDurchlaufDays': 'days',
  'lm.dashTopMaterial': 'Top 5 Materials by Value',
  'lm.dashColMatnr': 'Material No.',
  'lm.dashColMaktx': 'Description',
  'lm.dashColBestand': 'Stock',
  'lm.dashColWert': 'Value (EUR)',
  'lm.dashAktivitaeten': 'Recent Warehouse Activities',
  'lm.dashActWareneingang': 'Goods Receipt',
  'lm.dashActAuslagerung': 'Goods Issue',
  'lm.dashActUmlagerung': 'Transfer',
  'lm.dashActMaterial': 'Material',
  'lm.dashActMenge': 'Qty',
  'lm.dashActDatum': 'Date',
  'lm.dashActBenutzer': 'User',
  'lm.dashKritischUnit': 'materials',
  'lm.dashOffeneBanfUnit': 'requests',

  // Lager-Shell / Sidebar / Drill-down (Phase Dashboard-v2)
  'lm.navDashboard': 'Dashboard',
  'lm.navLagerbestand': 'Inventory',
  'lm.navBanfStatus': 'PR Status',
  'lm.navDurchlaufzeiten': 'Lead Times',
  'lm.navBerichte': 'Reports',
  // Lead-times section
  'lm.dlzTitle': 'Lead Times – planned delivery times',
  'lm.dlzSubtitle': 'Planned delivery times (info record) by material group & vendor · target {target} days',
  'lm.dlzEmpty': 'No lead-time data (info records) available.',
  'lm.dlzNoWerk': 'Please select a plant first (e.g. in Dashboard or Stock).',
  'lm.dlzDays': 'days',
  'lm.dlzOk': 'On target',
  'lm.dlzWatch': 'Borderline',
  'lm.dlzRisk': 'Too long',
  'lm.dlzKpiAvg': 'Avg. planned lead time',
  'lm.dlzTargetSub': 'target {target} days',
  'lm.dlzKpiFastest': 'Fastest material group',
  'lm.dlzKpiSlowest': 'Slowest material group',
  'lm.dlzKpiRisk': 'At-risk material groups',
  'lm.dlzKpiRiskSub': '> target {target} days',
  'lm.dlzKpiAvgInfo': 'Material-weighted average of planned delivery times (info record APLFZ) across the plant’s material groups.',
  'lm.dlzKpiFastestInfo': 'Material group with the lowest average planned delivery time.',
  'lm.dlzKpiSlowestInfo': 'Material group with the highest average planned delivery time.',
  'lm.dlzKpiRiskInfo': 'Number of material groups whose average exceeds the target ({target} d) by more than 20%.',
  'lm.dlzKpiSingleSource': 'Single-source risk',
  'lm.dlzKpiSingleSourceSub': 'of {total} materials',
  'lm.dlzKpiSingleSourceInfo': 'Materials with only ONE info-record vendor — supply risk, no fallback source.',
  'lm.dlzKpiSavings': 'Savings potential',
  'lm.dlzKpiSavingsSub': '{count} mat. with alternatives',
  'lm.dlzKpiSavingsInfo': 'Median price spread (most vs. least expensive vendor per material). Median = robust to outliers.',
  'lm.dlzKpiSpread': 'Lead-time spread',
  'lm.dlzKpiSpreadSub': 'slowest − fastest group',
  'lm.dlzKpiSpreadInfo': 'Difference slowest − fastest material group (avg planned lead time). Per bar: min–max range.',
  'lm.dlzByWg': 'Lead time by material group',
  'lm.dlzColZiel': 'Target',
  'lm.dlzLegende': 'Traffic light: green ≤ target · amber up to +20% · red above. Dashed = target.',
  'lm.dlzSupplierTitle': 'Vendor comparison',
  'lm.dlzColLieferant': 'Vendor',
  'lm.dlzColMaterialien': 'Materials',
  'lm.dlzColWg': 'Material groups',
  'lm.dlzColLieferzeit': 'Avg. lead time',
  'lm.dlzColStatus': 'Status',
  'lm.dlzSapHint': 'Actual lead times, on-time delivery (OTD), compliance and trend follow with the SAP goods-receipt history (EKBE). Currently: planned delivery times from info records.',
  // Reports section
  'lm.berichteTitle': 'Reports',
  'lm.berichteSubtitle': 'Metrics & export reports',
  'lm.repKpiBanfMonat': 'PRs this month',
  'lm.repKpiBanfMonatSub': 'newly created',
  'lm.repKpiWertJahr': 'Order value (year)',
  'lm.repKpiWertJahrSub': 'sum of PRs',
  'lm.repKpiOffen': 'Open PRs',
  'lm.repKpiOffenSub': 'pending approval',
  'lm.repHubTitle': 'Export reports (.xlsx)',
  'lm.repBestand': 'Stock list',
  'lm.repBestandDesc': 'All materials with stock',
  'lm.repHandlung': 'Action required',
  'lm.repHandlungDesc': 'Below reorder point, no open PR/order',
  'lm.repKritisch': 'Critical stock',
  'lm.repKritischDesc': 'Below safety stock / critical',
  'lm.repKonsi': 'Special stocks',
  'lm.repKonsiDesc': 'Consignment + subcontracting — with type, SOBKZ & vendor',
  'lm.repAlle': 'Full stock',
  'lm.repAlleDesc': 'All materials of the plant',
  'lm.repBanf': 'PR list',
  'lm.repBanfDesc': 'Purchase requisitions this year',
  'lm.repDownload': 'Download Excel',
  'lm.repError': 'Export failed',
  'lm.repEmpty': '0 matches in this plant — nothing to export.',
  'lm.repHubHint': 'Reports reuse the current warehouse filter/export logic; scoped per plant.',
  // BANF status section
  'lm.banfTitle': 'Open Purchase Requisitions',
  'lm.banfSubtitle': '{count} PRs',
  'lm.banfKpiPending': 'Pending Approval',
  'lm.banfKpiPendingUnit': 'open',
  'lm.banfKpiApproved': 'Approved',
  'lm.banfKpiApprovedUnit': 'released',
  'lm.banfKpiRisiko': 'With Delivery Risk',
  'lm.banfKpiRisikoUnit': 'due soon / overdue',
  'lm.banfKpiWert': 'Total Value',
  'lm.banfKpiWertUnit': 'all PRs',
  'lm.banfFilterAlle': 'All statuses',
  'lm.banfFilterPending': 'Open',
  'lm.banfFilterApproved': 'Approved',
  'lm.banfFilterRejected': 'Rejected',
  'lm.banfSearch': 'Search PR no., short text or material…',
  'lm.banfAllWerke': 'All plants',
  'lm.banfFilterWerk': 'Plant',
  'lm.banfAllWg': 'All material groups',
  'lm.banfAllAnf': 'All requesters',
  'lm.banfRiskOnly': 'Delivery risk only',
  'lm.banfSort': 'Sort',
  'lm.banfSortBedarf': 'Required date',
  'lm.banfSortDatum': 'Request date',
  'lm.banfSortWert': 'Value',
  'lm.banfBedarf': 'Required date',
  'lm.banfBedarfVon': 'Required from',
  'lm.banfBedarfBis': 'Required until',
  'lm.banfRiskBadge': 'Delivery risk',
  'lm.banfErstelltAm': 'Created',
  'lm.banfEmpty': 'No purchase requisitions found.',
  'lm.banfStepErstellt': 'Created',
  'lm.banfStepGenehmigt': 'Approved',
  'lm.banfStepBestellt': 'Ordered',
  'lm.banfStepGeliefert': 'Delivered',
  'lm.banfDetailAnforderer': 'Requester',
  'lm.banfDetailKostenstelle': 'Cost center (requester)',
  'lm.banfDetailPos': 'Item',
  'lm.banfDetailMenge': 'Qty',
  'lm.banfDetailWerk': 'Plant / Location',
  'lm.banfDetailKontierung': 'Account assignment',
  'lm.banfDetailWunschlief': 'Preferred vendor',
  'lm.banfFilterStatus': 'Status',
  'lm.banfFilterWg': 'Material group',
  'lm.banfFilterAnforderer': 'Requester',
  'lm.banfFilterKostenstelle': 'Cost center',
  'lm.banfFilterAuftrag': 'Order',
  'lm.banfFilterSachkonto': 'G/L account',
  'lm.rememberFilter': 'Remember filter',
  'lm.rememberFilterHint': 'Remember the current filter and re-apply it automatically on next login',
  'lm.banfSortKostenstelle': 'Cost center',
  'lm.banfSortAuftrag': 'Order',
  'lm.banfKontierung': 'Account assignment',
  'lm.banfKontKostenstelle': 'Cost center',
  'lm.banfKontSachkonto': 'G/L account',
  'lm.banfKontAuftrag': 'Order',
  'lm.banfKontPsp': 'WBS element',
  'lm.banfReset': 'Reset',
  'lm.banfResetAll': 'Reset all filters',
  'lm.banfSearchOpt': 'Search…',
  'lm.dashSoon': 'Coming soon',
  'lm.kritischChip': 'Critical Stock',
  'lm.backToHome': 'Back to Home',
  'lm.drilldownClickable': 'Click for details',

  // ATP / Availability (Phase 4c)
  'lm.atpTitle': 'ATP / Availability (MD04)',
  'lm.atpLoading': 'Loading availability...',
  'lm.atpError': 'Error loading availability',
  'lm.atpEmpty': 'No planning data available',
  'lm.atpBestand': 'Stock',
  'lm.atpZugaenge': 'Expected Receipts',
  'lm.atpAbgaenge': 'Planned Issues',
  'lm.atpVerfuegbarNetto': 'Available (Net)',
  'lm.atpExpand': 'Show details',
  'lm.atpCollapse': 'Hide details',
  'lm.atpZugaengeTitle': 'Receipts',
  'lm.atpAbgaengeTitle': 'Issues',
  'lm.atpElementTyp': 'Element Type',
  'lm.atpBeleg': 'Document',
  'lm.atpMenge': 'Qty',
  'lm.atpTermin': 'Date',
  'lm.atpZugaengeEmpty': 'No receipts planned',
  'lm.atpAbgaengeEmpty': 'No issues planned',

  // Export buttons (Dashboard-v2 Round D)
  'lm.exportXlsx': 'Export Excel',
  'lm.exportDetailXlsx': 'Detail as Excel',
  'lm.exportLoading': 'Exporting...',
  'lm.exportError': 'Export failed',
};

export default wm;
